export const newEvent = (
  type: string,
  { bubbles = false, cancelable = false, composed = false, detail = { pageNumber: 0 } } = {}
) => {
  if (typeof window.CustomEvent === 'function') {
    return new window.CustomEvent(type, { bubbles, cancelable, composed, detail });
  }
  const event = document.createEvent('CustomEvent');
  event.initCustomEvent(type, bubbles, cancelable, detail);
  return event;
};
